import React from "react";
import { Paper as MUIPaper } from "@mui/material";
import styled from "styled-components";

const StyledMUIPaper = styled(MUIPaper)`
  border-radius: 16px !important;
  margin: 8px !important;
  padding: 12px !important;
`;

export const Paper = (props) => {
  return <StyledMUIPaper {...props} />;
};
